import Boot from './boot.js';
import Lose from './lose.js';
import Win from './win.js';
import Level from './level.js';
import mainMenuScene from './menuScene.js';
import Phaser from 'phaser'

/**
 * Inicio del juego en Phaser. Creamos el archivo de configuración del juego y creamos
 * la clase Game de Phaser, encargada de crear e iniciar el juego.
 */
let config = {
    type: Phaser.AUTO,
    width: 1152,
    height: 640,
    renderer: Phaser.CANVAS,
    parent: 'CanvasDiv',
    scale: {
        // mode: Phaser.Scale.FIT,  
        autoCenter: Phaser.Scale.CENTER_HORIZONTALLY,
        isPortrait: true
    },
    pixelArt: true,
    scene: [Boot, mainMenuScene, Level, Lose, Win],
    physics: {
        default: 'arcade',
        arcade: {
            gravity: { y: 0 },
            debug: false
        }
    },
    input: {
        gamepad:true
    }
    
};

new Phaser.Game(config);
